import { useEventBus } from '@restify/packages/helpers/bus'
import { type Stores } from './useStores'
import { type ObjectMapped } from '@restify/packages/components/Map/types'

const appBus = useEventBus<{
  'order-tap': Stores['orders']['Result']
  'table-tap': {
    order: Stores['orders']['Result'] | null,
    object: {
      object: ObjectMapped['object']
      tableVariant: ObjectMapped['tableVariant']
    }
  }
  'order-modal-dismiss': void
  'order-modal-update': {
    orderId: string,
    objectId?: string,
  }
  'app-visible': void
  'app-hidden': void
}>('app')

export default () => appBus